export default __webpack_public_path__ + "static/media/chicken.b64a3880.svg";